module.exports = __webpack_public_path__ + "static/img/1014.19d8be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/totalBattery/1014.png
// module id = KL9/
// module chunks = 167